module.exports = __webpack_public_path__ + "static/media/mudskipper.e15f52c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/mudskipper.png
// module id = 324
// module chunks = 0